export enum PickupStatus {
    Cancelled = -1,
    Open = 0,
    Delivered = 1
}

export const PickupStatusMetadata = {
    '-1': {
        display: 'Cancelled',
        class: 'cancelled',
        value: -1
    },
    '0': {
        display: 'Open',
        class: 'open',
        value: 0
    },
    '1': {
        display: 'Delivered',
        class: 'delivered',
        value: 1
    }
};
